// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"wp-z","slideIn":"xp-z"};